import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/media',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:19
* @route 'https://org.proexpert.app/org/media'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:49
* @route 'https://org.proexpert.app/org/media'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:49
* @route 'https://org.proexpert.app/org/media'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:49
* @route 'https://org.proexpert.app/org/media'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:49
* @route 'https://org.proexpert.app/org/media'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:49
* @route 'https://org.proexpert.app/org/media'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::alt
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:77
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
export const alt = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: alt.url(args, options),
    method: 'put',
})

alt.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/media/{medium}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::alt
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:77
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
alt.url = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { medium: args }
    }

    if (Array.isArray(args)) {
        args = {
            medium: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        medium: args.medium,
    }

    return alt.definition.url
            .replace('{medium}', parsedArgs.medium.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::alt
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:77
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
alt.put = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: alt.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::alt
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:77
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
const altForm = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: alt.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::alt
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:77
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
altForm.put = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: alt.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

alt.form = altForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:99
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
export const destroy = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: 'https://org.proexpert.app/org/media/{medium}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:99
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
destroy.url = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { medium: args }
    }

    if (Array.isArray(args)) {
        args = {
            medium: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        medium: args.medium,
    }

    return destroy.definition.url
            .replace('{medium}', parsedArgs.medium.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:99
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
destroy.delete = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:99
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
const destroyForm = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgPlatformMediaController::destroy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgPlatformMediaController.php:99
* @route 'https://org.proexpert.app/org/media/{medium}'
*/
destroyForm.delete = (args: { medium: string | number } | [medium: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const media = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    alt: Object.assign(alt, alt),
    destroy: Object.assign(destroy, destroy),
}

export default media